module.exports = "/assets/cola-page/bottle_2@2x.png?vC61S/l";